import callApi from "helpers/callApi";

/** Bulk payload including deadlines (no offset/limit). */
export function getNotificationCenter() {
  return callApi("/notify/notification_center", "GET", { only_active: true });
}

export function getNotificationCenterTable(tableId, params = {}) {
  const safeId = encodeURIComponent(String(tableId ?? "").trim());
  return callApi(`/notify/notification_center/${safeId}`, "GET", {
    only_active: true,
    ...params,
  });
}

export function getNotificationCenterCounters(params = {}) {
  return callApi("/notify/notification_center/counters", "GET", params);
}
